module.exports = __webpack_public_path__ + "img/20190712164549096.c2aa68b1.png";